const state = {
  busy: false,
  submitted: false,
  races: {},
  ethnics: {},
  religions: {},
  sexes: {},
  banks: {},
  academicLevelOthers: {},
  spmSubject: {},
  certificates: {},
  relationships: {},
  field: {},
  age: 0,
  showHistory: false,
  statusHistory: {}
}

const mutations = {
  UPDATE_SUBMITTED(state, submitted) {
    state.submitted = submitted
  },
  UPDATE_BUSY(state, busy) {
    state.busy = busy
  },
  UPDATE_RACES(state, races) {
    state.races = races
  },
  UPDATE_ETHNICS(state, ethnics) {
    state.ethnics = ethnics
  },
  UPDATE_RELIGIONS(state, religions) {
    state.religions = religions
  },
  UPDATE_SEXES(state, sexes) {
    state.sexes = sexes
  },
  UPDATE_BANKS(state, banks) {
    state.banks = banks
  },
  UPDATE_ACADEMIC_LEVEL_OTHERS(state, academicLevelOthers) {
    state.academicLevelOthers = academicLevelOthers
  },
  UPDATE_SPM_SUBJECT(state, spmSubject) {
    state.spmSubject = spmSubject
  },
  UPDATE_CERTIFICATES(state, certificates) {
    state.certificates = certificates
  },
  UPDATE_RELATIONSHIPS(state, relationships) {
    state.relationships = relationships
  },
  UPDATE_FIELD(state, field) {
    state.field = field
  },
  UPDATE_PROGRAME_CODE(state, programCode) {
    state.programCode = programCode
  },
  UPDATE_AGE(state, age) {
    state.age = age
  },
  UPDATE_SHOW_HISTORY(state, showHistory) {
    state.showHistory = showHistory
  },
  UPDATE_STATUS_HISTORY(state, statusHistory) {
    state.statusHistory = statusHistory
  }
}

const actions = {
  updateBusy({
    commit
  }, busy) {
    commit('UPDATE_BUSY', busy);
  },
  updateSubmitted({
    commit
  }, submitted) {
    commit('UPDATE_SUBMITTED', submitted);
  },
  updateRaces({
    commit
  }, races) {
    commit('UPDATE_RACES', races);
  },
  updateEthnics({
    commit
  }, ethnics) {
    commit('UPDATE_ETHNICS', ethnics);
  },
  updateReligions({
    commit
  }, religions) {
    commit('UPDATE_RELIGIONS', religions);
  },
  updateSexes({
    commit
  }, sexes) {
    commit('UPDATE_SEXES', sexes);
  },
  updateBanks({
    commit
  }, banks) {
    commit('UPDATE_BANKS', banks);
  },
  updateAcademicLevelOthers({
    commit
  }, academicLevelOthers) {
    commit('UPDATE_ACADEMIC_LEVEL_OTHERS', academicLevelOthers);
  },
  updateSpmSubject({
    commit
  }, spmSubject) {
    commit('UPDATE_SPM_SUBJECT', spmSubject);
  },
  updateCertificateType({
    commit
  }, certificates) {
    commit('UPDATE_CERTIFICATES', certificates);
  },
  updateRelationships({
    commit
  }, relationships) {
    commit('UPDATE_RELATIONSHIPS', relationships);
  },
  updateField({
    commit
  }, field) {
    commit('UPDATE_FIELD', field);
  },
  updateProgrameCode({
    commit
  }, programCode) {
    commit('UPDATE_PR0GRAME_CODE', programCode);
  },
  updateAge({
    commit
  }, age) {
    commit('UPDATE_AGE', age);
  },
  updateShowHistory({
    commit
  }, showHistory) {
    commit('UPDATE_SHOW_HISTORY', showHistory);
  },
  updateStatusHistory({
    commit
  }, statusHistory) {
    commit('UPDATE_STATUS_HISTORY', statusHistory);
  }
}

const getters = {
  Busy: state => {
    return state.busy
  },
  Submitted: state => {
    return state.submitted
  },
  Races: state => {
    return state.races
  },
  Ethnics: state => {
    return state.ethnics
  },
  Religions: state => {
    return state.religions
  },
  Sexes: state => {
    return state.sexes
  },
  Banks: state => {
    return state.banks
  },
  AcademicLevelOthers: state => {
    return state.academicLevelOthers
  },
  SpmSubject: state => {
    return state.spmSubject
  },
  Certificates: state => {
    return state.certificates
  },
  Relationships: state => {
    return state.relationships
  },
  Field: state => {
    return state.field
  },
  ProgramCode: state => {
    return state.programCode
  },
  Age: state => {
    return state.age
  },
  ShowHistory: state => {
    return state.showHistory
  },
  StatusHistory: state => {
    return state.statusHistory
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
